export const bookingApprovalsKeys = {
  all: () => ["bookingsApprovals"],
  list: (...params: unknown[]) => [...bookingApprovalsKeys.all(), "list", ...params],
  single: (id: number) => [...bookingApprovalsKeys.all(), id.toString()],
  approve: (...ids: number[]) => [...bookingApprovalsKeys.all(), ...ids, "approve"],
  reject: (...ids: number[]) => [...bookingApprovalsKeys.all(), ...ids, "reject"],
  request: (...ids: number[]) => [...bookingApprovalsKeys.all(), ...ids, "request"],
  counters: (...params: unknown[]) => [...bookingApprovalsKeys.all(), "counters", params]
};
